<template>
  <v-card class="d-flex flex-column align-center pa-4">
    <v-card-title class="headline font-weight-bold mb-4">
      Escolha o destino do Cashposto
    </v-card-title>
    <v-card-text class="pa-0">
      <v-select
        v-model="opcaoSelecionada"
        :items="opcoes"
        label="Selecione uma opção"
        item-text="text"
        item-value="value"
        class="selection-field"
        style="max-width: 500px; margin: 0 auto;"
      ></v-select>
    </v-card-text>
    <v-card-actions class="d-flex space-between pa-0 mt-4">
      <v-btn round @click="voltar">Voltar</v-btn>
      <v-btn round color="primary" @click="alterar">Salvar</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      opcaoSelecionada: undefined,
      opcoes: [
        { text: 'Somente Posto', value: 1 },
        { text: 'Somente Empresas', value: 2 },
        { text: 'Posto e Empresa', value: 3 }
      ]
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    }
  },
  methods: {
    alterar () {
      this.$store.dispatch('editarPosto', { destino_cashposto: this.opcaoSelecionada }).then((response) => {
        if (response === 'OK') {
          this.$emit('showSnackbar', 'success', 'Destino do Cashposto salvo com sucesso!')
          this.opcaoSelecionada = this.posto.destino_cashposto
        } else {
          this.$emit('showSnackbar', 'error', 'Erro ao alterar destino do Cashposto!')
        }
      })
    },
    voltar () {
      this.$emit('fechar')
    }
  },
  mounted () {
    if (this.posto) {
      console.log(this.posto)
      this.opcaoSelecionada = this.posto.destino_cashposto
    }
  }
}
</script>
